import { render, staticRenderFns } from "./YourCustomTreatment.vue?vue&type=template&id=03baadec&scoped=true&"
import script from "./YourCustomTreatment.vue?vue&type=script&lang=js&"
export * from "./YourCustomTreatment.vue?vue&type=script&lang=js&"
import style0 from "./YourCustomTreatment.vue?vue&type=style&index=0&id=03baadec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03baadec",
  null
  
)

export default component.exports